import { formatDateTime } from "../../sUtils/dateUtils";

const EVENT_TYPES = [
  "event",
  "travel",
  "office",
  "rest",
  "training",
  "no_job",
];

function ViewingEventModal({
  isOpen,
  onClose,
  selectedEvent,
  setIsEditing,
  setIsEditModalOpen,
  handleDeleteEvent,
}) {
  if (
    !isOpen ||
    !selectedEvent ||
    !EVENT_TYPES.includes(selectedEvent.event_type)
  ) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-xl shadow-xl max-w-md w-full font-sans relative">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>

        <h2 className="text-xl font-bold mb-4">
          {selectedEvent.title}
        </h2>

        <p>
          <b>Date:</b> {formatDateTime(selectedEvent.start)}
        </p>

        <p>
          <b>Description:</b> {selectedEvent.description || "-"}
        </p>

        <p>
          <b>Primary Technician:</b>{" "}
          {selectedEvent.primary_technician || "-"}
        </p>

        <div className="mt-4 flex justify-end gap-3">
          <button
            onClick={() => {
              setIsEditing(true);
              setIsEditModalOpen(true);
            }}
            className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
          >
            Edit
          </button>

          <button
            onClick={handleDeleteEvent}
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewingEventModal;